/* DO NOT EDIT! This file is auto-generated by graphql-code-generator - see `codegen.yml` */
import * as Types from './types';

import gql from 'graphql-tag';
import * as Urql from '../../abstractions/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type GetTermsheetsForListQueryVariables = Types.Exact<{
  query?: Types.InputMaybe<Types.Scalars['JSON']>;
  sort?: Types.InputMaybe<Types.Scalars['JSON']>;
  limit?: Types.InputMaybe<Types.Scalars['Int']>;
  skip?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type GetTermsheetsForListQuery = { __typename?: 'Query', termsheets: { __typename?: 'TermsheetListResponse', data: Array<{ __typename?: 'Termsheet', id: number, name: string, updatedAt?: any | null }>, pageData?: { __typename?: 'PageData', count: number, limit: number } | null } };

export type GetTermsheetsForDropdownQueryVariables = Types.Exact<{
  query?: Types.InputMaybe<Types.Scalars['JSON']>;
  sort?: Types.InputMaybe<Types.Scalars['JSON']>;
  limit?: Types.InputMaybe<Types.Scalars['Int']>;
  skip?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type GetTermsheetsForDropdownQuery = { __typename?: 'Query', termsheets: { __typename?: 'TermsheetListResponse', data: Array<{ __typename?: 'Termsheet', id: number, name: string, termsheetType: Types.TermsheetType, terms: any, createdAt?: any | null, updatedAt?: any | null, version?: number | null }>, pageData?: { __typename?: 'PageData', count: number, limit: number } | null } };

export type GetTermsheetQueryVariables = Types.Exact<{
  query: Types.Scalars['JSON'];
}>;


export type GetTermsheetQuery = { __typename?: 'Query', termsheet: { __typename?: 'Termsheet', id: number, name: string, termsheetType: Types.TermsheetType, terms: any, createdAt?: any | null, updatedAt?: any | null, version?: number | null } };

export type TermsheetDataFragment = { __typename?: 'Termsheet', id: number, name: string, termsheetType: Types.TermsheetType, terms: any, createdAt?: any | null, updatedAt?: any | null, version?: number | null };

export type SaveTermsheetMutationVariables = Types.Exact<{
  termsheet: Types.TermsheetInput;
}>;


export type SaveTermsheetMutation = { __typename?: 'Mutation', saveTermsheet: { __typename?: 'Termsheet', id: number, name: string, termsheetType: Types.TermsheetType, terms: any, createdAt?: any | null, updatedAt?: any | null, version?: number | null } };

export type ExportTermsheetsQueryVariables = Types.Exact<{
  termsheetIds: Array<Types.Scalars['Int']> | Types.Scalars['Int'];
}>;


export type ExportTermsheetsQuery = { __typename?: 'Query', exportTermsheets: string };

export const TermsheetDataFragmentDoc = gql`
    fragment TermsheetData on Termsheet {
  id
  name
  termsheetType
  terms
  createdAt
  updatedAt
  version
}
    `;
export const GetTermsheetsForListDocument = gql`
    query GetTermsheetsForList($query: JSON, $sort: JSON, $limit: Int, $skip: Int) {
  termsheets(query: $query, sort: $sort, limit: $limit, skip: $skip) {
    data {
      id
      name
      updatedAt
    }
    pageData {
      count
      limit
    }
  }
}
    `;

export function useGetTermsheetsForListQuery(options?: Omit<Urql.UseQueryArgs<GetTermsheetsForListQueryVariables>, 'query'>) {
  return Urql.useQuery<GetTermsheetsForListQuery>({ query: GetTermsheetsForListDocument, ...options });
};
export const GetTermsheetsForDropdownDocument = gql`
    query GetTermsheetsForDropdown($query: JSON, $sort: JSON, $limit: Int, $skip: Int) {
  termsheets(query: $query, sort: $sort, limit: $limit, skip: $skip) {
    data {
      ...TermsheetData
    }
    pageData {
      count
      limit
    }
  }
}
    ${TermsheetDataFragmentDoc}`;

export function useGetTermsheetsForDropdownQuery(options?: Omit<Urql.UseQueryArgs<GetTermsheetsForDropdownQueryVariables>, 'query'>) {
  return Urql.useQuery<GetTermsheetsForDropdownQuery>({ query: GetTermsheetsForDropdownDocument, ...options });
};
export const GetTermsheetDocument = gql`
    query GetTermsheet($query: JSON!) {
  termsheet(query: $query) {
    ...TermsheetData
  }
}
    ${TermsheetDataFragmentDoc}`;

export function useGetTermsheetQuery(options: Omit<Urql.UseQueryArgs<GetTermsheetQueryVariables>, 'query'>) {
  return Urql.useQuery<GetTermsheetQuery>({ query: GetTermsheetDocument, ...options });
};
export const SaveTermsheetDocument = gql`
    mutation SaveTermsheet($termsheet: TermsheetInput!) {
  saveTermsheet(termsheet: $termsheet) {
    ...TermsheetData
  }
}
    ${TermsheetDataFragmentDoc}`;

export function useSaveTermsheetMutation() {
  return Urql.useMutation<SaveTermsheetMutation, SaveTermsheetMutationVariables>(SaveTermsheetDocument);
};
export const ExportTermsheetsDocument = gql`
    query ExportTermsheets($termsheetIds: [Int!]!) {
  exportTermsheets(termsheetIds: $termsheetIds)
}
    `;

export function useExportTermsheetsQuery(options: Omit<Urql.UseQueryArgs<ExportTermsheetsQueryVariables>, 'query'>) {
  return Urql.useQuery<ExportTermsheetsQuery>({ query: ExportTermsheetsDocument, ...options });
};